{
  "hero.title": "Hi, I'm <span class=\"name\">André</span>.",
  "hero.desc": "I'll publish about <strong>software engineering</strong> here.<br />Notes, demos, and experiments on building systems that are pleasant to\n        maintain, easy to understand, and reliable in production.",
  "labs.title": "Labs",
  "labs.desc": "Demos and experiments.",
  "labs.todo.title": "Todo",
  "labs.todo.desc": "Local-first, E2E-encrypted. WebAuthn PRF key derivation, Yjs CRDT, AES-GCM relay sync.",
  "labs.modulith.title": "Frontend Modulith",
  "labs.modulith.desc": "One build, one deploy — module boundaries enforced at compile time. No microfrontends, no runtime federation.",
  "labs.federation.title": "Module Federation",
  "labs.federation.desc": "The same demo, rebuilt as independently deployed microfrontends — module boundaries enforced at runtime instead of compile time.",
  "labs.wanderlust.title": "Wanderlust",
  "labs.wanderlust.desc": "A Kubernetes-native travel planner — Angular, gRPC, saga orchestration, feature flags, and full-stack observability, deployed to a real cluster.",
  "contact.title": "Contact",
  "contact.desc": "Drop me a message. Leave your email if you want a reply.",
  "contact.field.email": "Your email",
  "contact.field.email.optional": "(optional)",
  "contact.field.message": "Message",
  "contact.submit": "Send message",
  "not-found.back": "← Home",
  "contact.status.pending": "Sending…",
  "contact.status.ok": "Thanks! Your message is on its way.",
  "contact.status.error.generic": "Something went wrong. Please try again later.",
  "contact.status.error.validation": "Please fill in the required fields correctly."
}
